import Vue from 'vue'
/*import VueGtag from "vue-gtag"
Vue.use(VueGtag, {
  config: { id: "UA-4272990-14" },
  pageTrackerTemplate(to) {
    return {
      page_title: 'Food Cheatsheet',
      page_path: '/'+to.params.locale
    }
  }
})*/
import App from './App.vue'
import i18n from './i18n'
import router from './routes'

import "@/assets/styles/main.css"
import VIcon from 'vue-tailwind-icons'
//using namespace of here: https://heroicons.com/
Vue.use(VIcon, { set: 'outline' })
import FlagIcon from 'vue-flag-icon'
Vue.use(FlagIcon)

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')


//https://picsum.photos/images